type LogLevel = "debug" | "info" | "warn" | "error";

interface LogContext {
  [key: string]: unknown;
}

class Logger {
  private isDev = import.meta.env.DEV;

  private log(level: LogLevel, message: string, context?: LogContext) {
    if (!this.isDev) return;

    const timestamp = new Date().toISOString();

    switch (level) {
      case "debug":
        console.debug(`[${timestamp}] DEBUG:`, message, context || "");
        break;
      case "info":
        console.info(`[${timestamp}] INFO:`, message, context || "");
        break;
      case "warn":
        console.warn(`[${timestamp}] WARN:`, message, context || "");
        break;
      case "error":
        console.error(`[${timestamp}] ERROR:`, message, context || "");
        break;
    }
  }

  debug(message: string, context?: LogContext) {
    this.log("debug", message, context);
  }

  info(message: string, context?: LogContext) {
    this.log("info", message, context);
  }

  warn(message: string, context?: LogContext) {
    this.log("warn", message, context);
  }

  error(message: string, context?: LogContext) {
    this.log("error", message, context);
  }
}

export const logger = new Logger();
